import { Component, ChangeDetectionStrategy } from '@angular/core';
import { IFilterParams, IDoesFilterPassParams, RowNode } from 'ag-grid-community/main';
import { AgFilterComponent } from 'ag-grid-angular/main';

type Option = 'Yes' | 'No';

type Model = {
    values: Option[];
};

@Component({
    selector: 'boolean-filter-cell',
    template: require('./boolean-filter.component.html'),
    styles: [require('./boolean-filter.component.scss')],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class BooleanFilterComponent implements AgFilterComponent {
    public options: Option[] = ['Yes', 'No'];
    public chosenOptions: Option[] = this.options;

    private params: IFilterParams;
    private valueGetter: (rowNode: RowNode) => boolean;

    public agInit(params: IFilterParams): void {
        this.params = params;
        this.valueGetter = params.valueGetter;
    }

    public isFilterActive(): boolean {
        return !!this.chosenOptions;
    }

    public doesFilterPass(params: IDoesFilterPassParams): boolean {
        switch (this.chosenOptions.length) {
            case 2: {
                return true;
            }
            case 1: {
                return this.valueGetter(params.node) === (this.chosenOptions[0] === 'Yes');
            }
            case 0:
            default: {
                return false;
            }
        }
    }

    public getModel(): Model {
        return { values: this.chosenOptions };
    }

    public setModel(model: Model): void {
        if (!model) {
            return;
        }
        this.chosenOptions = model.values;
    }

    public onChange(newFlags: Option[]) {
        this.chosenOptions = newFlags;
        this.params.filterChangedCallback();
    }
}